// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c7be339f","455":"ee9e83b5"}[chunkId] + ".chunk.js";
};